import {
    LOAD_INDUCT_PACKAGE_METRICS_FOR_ROUTE,
    LOAD_METRICS_FOR_ROUTE_CALL_BEGIN,
    LOAD_METRICS_FOR_ROUTE_CALL_FAILURE,
    LOAD_PLANNED_PACKAGE_METRICS_FOR_ROUTE,
    LOAD_STOW_ASSOCIATE_METRICS_FOR_ROUTE,
    LOAD_STOW_PACKAGE_METRICS_FOR_ROUTE
} from "../actions/RouteActions";

/**
 * Initial state of the system.
 */
const initialState = {
    loading: true,
    stowPackageMetricsMap: {},
    plannedPackageMetricsMap: {},
    inductPackageMetricsMap: {},
    stowAssociateMetricsMap: {},
}

/**
 * Reducer function for Route View that changes state
 * based on the action triggered.
 */
export default function routeReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_METRICS_FOR_ROUTE_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_STOW_PACKAGE_METRICS_FOR_ROUTE:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_PLANNED_PACKAGE_METRICS_FOR_ROUTE:
            return {
                ...state,
                loading: false,
                plannedPackageMetricsMap: action.plannedPackageMetricsMap
            };
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_ROUTE:
            return {
                ...state,
                loading: false,
                inductPackageMetricsMap: action.inductPackageMetricsMap
            };
        case LOAD_STOW_ASSOCIATE_METRICS_FOR_ROUTE:
            return {
                ...state,
                loading: false,
                stowAssociateMetricsMap: action.stowAssociateMetricsMap
            };
        case LOAD_METRICS_FOR_ROUTE_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/RouteReducer.js